// Generated by scripts/generate-app-version.mjs.
export const APP_RELEASE = {
  "version": "1.0.0",
  "buildId": "20261103T185211986Z",
  "builtAt": "2026-11-03T18:52:11.986Z"
} as const;
